module.exports = __webpack_public_path__ + "img/tddg-1.88767f8e.jpg";